import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { MEAL_PLANS } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-accomodation',
  templateUrl: './accomodation.component.html',
  styleUrls: ['./accomodation.component.scss'],
})
export class AccomodationComponent implements OnInit {
  @Input() leadId: any;
  @Input() itineraryId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();
  @Output() hotelsDataUpdated: EventEmitter<any> = new EventEmitter();

  @Input() itineraryDetails: any;
  noOfAdults: number = 0;
  noOfChildren: number = 0;
  noOfInfants: number = 0;
  preferredDestinations: any;
  tripStartDate: string = '';
  tripEndDate: string = '';

  childrenAge: any = [];
  childrenBelowTwo: any = 0;
  childrenAboveTwo: any = 0;

  noOfAdutlsDropdown: any = [];
  noOfChildrenDropdown: any = [];



  @Input() storedFormData: any;
  @Input() editInventory: boolean = false;
  @Input() editQuote: boolean = false;

  @Input() serviceBasedSections: any;

  typesOfMeals: any = [];
  MEAL_PLAN = MEAL_PLANS;
  meals: any = [];
  accommodationType: any;

  roomType: any = [];

  roomCategory: any = [];

  accommodationForm!: FormGroup;

  constructor(
    private _lovDataService: LovDataService,
    private _fb: FormBuilder,
    private _itineraryService: ItineraryService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _validationService: InputValidationsService
  ) { }

  ngOnInit() {
    // Initilization of the variables
    this.noOfAdults = 0;
    this.noOfChildren = 0;
    this.noOfInfants = 0;
    this.childrenAboveTwo = 0;
    this.childrenBelowTwo = 0;
    this.childrenAge = [];
    this.noOfAdutlsDropdown = [];
    this.noOfChildrenDropdown = [];

    if (this.itineraryDetails) {
      this.updateAllItineraryData();

      this.preferredDestinations = this.itineraryDetails.destination;
      this.tripStartDate = this._globalService.formatDateTimeToDate(this.itineraryDetails.startDate);
      this.tripEndDate = this._globalService.formatDateTimeToDate(this.itineraryDetails.endDate);
    }

    this.accommodationForm = this._fb.group({
      sectionNote: [''],
      data: this._fb.array([]),
      hotelTermsAndConditions: [[]]
    });
    this.accommodationForm.valueChanges.subscribe(() => {
      this.accommodationForm.markAsTouched();
    })


    if (!this.serviceBasedSections.showTourPackage && !this.serviceBasedSections.showRouteCraft) {
      this.addValidationOfCost();
      this.accommodationForm.markAsPristine();
      this.accommodationForm.markAsUntouched();
    }

    // Loop through preferredDestinations and add destinations/locations/hotels accordingly
    const dataArray = this.destinationFormArray();
    dataArray.clear();
    let tempStartDate = this.tripStartDate;
    if (this.preferredDestinations && Array.isArray(this.preferredDestinations)) {
      this.preferredDestinations.forEach((destination, index) => {
        const endDate = this.getEndDate(tempStartDate, destination.days);
        const destinationGroup = this.createDestinationFormGroup(destination, tempStartDate, endDate, index);
        dataArray.push(destinationGroup);
        tempStartDate = endDate;
      });
      this.accommodationForm.markAsPristine();
      this.accommodationForm.markAsUntouched();
    }

    if (this.storedFormData) {
      this.patchAccommodationData(this.storedFormData);
      this.accommodationForm.patchValue({
        sectionNote: this.storedFormData.note || "",
        hotelTermsAndConditions: this.storedFormData.hotelTermsAndConditions || []
      });
    }

    this._lovDataService.getLovData("HotelType").subscribe((data) => {
      if (data) {
        this.accommodationType = data;
      }
    });
    this._lovDataService.getLovData("RoomCategory").subscribe((data) => {
      if (data) {
        this.roomCategory = data
      }
    });
    this._lovDataService.getLovData("RoomType").subscribe((data) => {
      if (data) {
        this.roomType = data;
      }
    });
    this._lovDataService.getLovData("Meals").subscribe((data) => {
      this.meals = data;
    })
    this._lovDataService.getLovData("HotelTermsAndConditions").subscribe((data) => {
      data.map((item: { addedByUser: boolean; }) => {
        item.addedByUser = false;
      })

      if (this.storedFormData) {
        this.accommodationForm.patchValue({
          hotelTermsAndConditions: this.storedFormData.hotelTermsAndConditions || []
        })
      } else {
        this.accommodationForm.patchValue({
          hotelTermsAndConditions: data || []
        })
      }
    })
  }

  get today() {
    return this._globalService.getTodaysDateTime();
  }
  convertToDate(value: any): Date {
    return new Date(value);
  }

  setTimeToGivenHours(hours: number): Date {
    const updatedDate = new Date(); // Clone the date to avoid mutating the original
    updatedDate.setHours(hours, 0, 0, 0); // Set hours, minutes, and seconds
    return updatedDate;
  }

  getEndDate(startDate: any, days: any): string {
    const startDateFormat: Date = new Date(startDate);
    const endDate = new Date(startDateFormat);
    endDate.setDate(startDateFormat.getDate() + days);
    const endDateFormatted = endDate.toISOString().split('T')[0];
    return endDateFormatted;
  }

  updateAllItineraryData() {
    this.noOfAdults = this.itineraryDetails.totalAdults;
    this.noOfChildren = this.itineraryDetails.totalChildrens;
    this.noOfInfants = this.itineraryDetails.totalInfants;

    this.noOfAdutlsDropdown = [{ value: this.noOfAdults, name: `${this.noOfAdults} Adults` }];
    for (let i = 0; i <= this.noOfChildren + this.noOfInfants; i++) {
      let item = {
        value: i,
        name: `${i} Children`
      }
      this.noOfChildrenDropdown.push(item);
    }
    this.childrenAboveTwo = this.noOfChildren;
    this.childrenBelowTwo = this.noOfInfants;
  }

  // Reactive form funtions
  createDestinationFormGroup(destination: any, startDate: any, endDate: any, index: number): FormGroup {
    let group = this._fb.group({
      destination: [destination.location],
      locations: this._fb.array([
        this.createLocationFormGroup(destination, startDate, endDate)
      ])
    }, { validators: this.validateDestinationNights(index) });

    return group;
  }




  createLocationFormGroup(destination: any, startDate: any, endDate: any): FormGroup {
    let group = this._fb.group({
      locationName: [destination?.location || "", [Validators.required]],
      hotels: this._fb.array([this.createHotelFormGroup(startDate, endDate, destination?.days || 0)]),
    })
    return group;
  }

  createHotelFormGroup(startDate: any, endDate: any, noOfNights: any): FormGroup {
    let group = this._fb.group({
      hotelName: ['', Validators.required],
      hotelType: ['', Validators.required],
      noOfRooms: [0, [Validators.required, this._validationService.valueNotZeroValidator()]],
      noOfNights: [noOfNights || 0, [Validators.required, this._validationService.valueNotZeroValidator()]],
      roomCategory: [''],
      roomType: [''],
      checkIn: [startDate ? this.convertToDate(startDate) : null, [Validators.required]],
      checkInTime: [this.setTimeToGivenHours(15)],
      checkOut: [endDate ? this.convertToDate(endDate) : null, [Validators.required]],
      checkOutTime: [this.setTimeToGivenHours(11)],
      mealPlan: [[]],
      costPerAdult: [{ inputValue: '', dropdownValue: this.noOfAdults }],
      costPerChild: [{ inputValue: '', dropdownValue: this.childrenAboveTwo }],
      costPerInfant: [{ inputValue: '', dropdownValue: this.childrenBelowTwo }],
      totalAccommodationCost: [{ value: 0, disabled: true }],
      extraBeds: [0]
    });
    if (this.noOfChildren) {
      this.addNoOfChildrenToggleSubscription(group)
    }

    if (this.noOfChildren === 0) {
      group.get('costPerChild')?.setValue({ inputValue: '', dropdownValue: null });
      group.get('costPerInfant')?.setValue({ inputValue: '', dropdownValue: null });

      group.get('costPerChild')?.updateValueAndValidity();
      group.get('costPerInfant')?.updateValueAndValidity();

      group.get('costPerChild')?.disable();
      group.get('costPerInfant')?.disable();
    }

    group.get('costPerAdult')?.valueChanges.subscribe((value) => {
      this.addCalculationSubscription(group);
    })
    group.get('costPerChild')?.valueChanges.subscribe((value) => {
      this.addCalculationSubscription(group);
    })
    group.get('costPerInfant')?.valueChanges.subscribe((value) => {
      this.addCalculationSubscription(group);
    })

    group.get("noOfNights")?.valueChanges.subscribe((value) => {
      this.updateDatesBasedOnNights(value, group);
    })
    return group;
  }

  updateDatesBasedOnNights(nights: any, formGroup: FormGroup) {
    const checkInControl = formGroup.get('checkIn');
    const checkOutControl = formGroup.get('checkOut');

    if (checkInControl && checkOutControl && nights && !isNaN(nights)) {
      const checkInDate = checkInControl.value ? new Date(checkInControl.value) : null;
      if (checkInDate instanceof Date && !isNaN(checkInDate.getTime())) {
        const newCheckOut = new Date(checkInDate);
        newCheckOut.setDate(checkInDate.getDate() + Number(nights));
        checkOutControl.setValue(newCheckOut);
        checkOutControl.updateValueAndValidity();
      }
    }
  }

  validateDestinationNights(destinationIndex: number): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const destinationGroup = group as FormGroup;
      const locationsArray = destinationGroup.get('locations') as FormArray;

      const preferredNights = this.preferredDestinations[destinationIndex]?.days || 0;
      let totalHotelNights = 0;
      let hasUnequalNightsInLocation = false;

      for (let i = 0; i < locationsArray.length; i++) {
        const locationGroup = locationsArray.at(i) as FormGroup;
        const hotelsArray = locationGroup.get('hotels') as FormArray;

        if (hotelsArray.length === 0) continue;

        const referenceNights = hotelsArray.at(0).get('noOfNights')?.value;

        for (let j = 0; j < hotelsArray.length; j++) {
          const hotelGroup = hotelsArray.at(j) as FormGroup;
          const hotelNights = hotelGroup.get('noOfNights')?.value;

          // Check for same nights in one location
          if (hotelNights !== referenceNights) {
            hasUnequalNightsInLocation = true;
          }
        }
          totalHotelNights += referenceNights;
      }

      if (hasUnequalNightsInLocation) {
        return { unequalHotelNightsInLocation: true };
      }

      if (totalHotelNights !== preferredNights) {
        return { totalHotelNightsMismatch: true };
      }

      return null;
    };
  }


  addCalculationSubscription(group: FormGroup) {
    let totalCost = 0;
    totalCost += group.get('costPerAdult')?.value.dropdownValue * group.get('costPerAdult')?.value.inputValue;
    totalCost += group.get('costPerChild')?.value.dropdownValue * group.get('costPerChild')?.value.inputValue;
    totalCost += group.get('costPerInfant')?.value.dropdownValue * group.get('costPerInfant')?.value.inputValue;
    group.get('totalAccommodationCost')?.setValue(totalCost);
    group.get('totalAccommodationCost')?.updateValueAndValidity();
  }

  addNoOfChildrenToggleSubscription(group: any) {
    // Subscribe to 'costPerChild' value changes
    group.get('costPerChild')?.valueChanges.subscribe((value: any) => {
      const currentWithoutBedValue = group.get('costPerInfant')?.value;
      const newWithoutBedValue = {
        inputValue: currentWithoutBedValue.inputValue,
        dropdownValue: (this.noOfChildren + this.noOfInfants) - value.dropdownValue
      };

      // Update 'costPerInfant' only if the values are different
      if (JSON.stringify(currentWithoutBedValue) !== JSON.stringify(newWithoutBedValue)) {
        group.get('costPerInfant')?.setValue(newWithoutBedValue, { emitEvent: false });
      }
    });

    // Subscribe to 'costPerInfant' value changes
    group.get('costPerInfant')?.valueChanges.subscribe((value: any) => {
      const currentWithBedValue = group.get('costPerChild')?.value;
      const newWithBedValue = {
        inputValue: currentWithBedValue.inputValue,
        dropdownValue: (this.noOfChildren + this.noOfInfants) - value.dropdownValue
      };

      // Update 'costPerChild' only if the values are different
      if (JSON.stringify(currentWithBedValue) !== JSON.stringify(newWithBedValue)) {
        group.get('costPerChild')?.setValue(newWithBedValue, { emitEvent: false });
      }
    });
  }

  destinationFormArray(): FormArray {
    return this.accommodationForm.get('data') as FormArray;
  }

  locationFormArray(destinationIndex: number): FormArray {
    return (this.destinationFormArray().at(destinationIndex).get('locations') as FormArray);
  }

  addLocation(destinationIndex: number, destination: any, startDate: any, endDate: any) {
    const locationGroup = this.createLocationFormGroup(destination, startDate, endDate);
    this.locationFormArray(destinationIndex).push(locationGroup);
  }

  removeLocation(destinationIndex: number, locationIndex: number) {
    this.locationFormArray(destinationIndex).removeAt(locationIndex);
    this.accommodationForm.markAsTouched();
    this.accommodationForm.markAsDirty();
  }

  hotelsFormArray(destinationIndex: number, locationIndex: number): FormArray {
    return (this.locationFormArray(destinationIndex).at(locationIndex).get('hotels') as FormArray);
  }

  addHotel(destinationIndex: number, locationIndex: number, startDate: any, endDate: any, noOfNights: any) {
    const hotelGroup = this.createHotelFormGroup(startDate, endDate, noOfNights);
    this.hotelsFormArray(destinationIndex, locationIndex).push(hotelGroup);
  }

  removeHotel(destinationIndex: number, locationIndex: number, hotelIndex: number) {
    this.hotelsFormArray(destinationIndex, locationIndex).removeAt(hotelIndex);
    this.accommodationForm.markAsTouched();
    this.accommodationForm.markAsDirty();
  }

  // Funtions to patch data
  patchAccommodationData(storedData: any) {
    const { data, ...remainingData } = storedData;
    this.patchDestinationsData(data);
  }

  patchDestinationsData(destinations: any[]) {
    const destinationArray = this.destinationFormArray();

    destinationArray.controls?.forEach((element: any, desIndex: number) => {
      const destination1 = element.get('destination').value?.toLowerCase();
      // find the destination in destinations array
      const matchedDes = destinations.find((destination: any) => destination?.destination?.toLowerCase() === destination1);
      if (matchedDes) {
        this.patchLocationsData(matchedDes.locations, desIndex);
      }

    });
  }

  patchLocationsData(locations: any[], destinationIndex: number) {
    const locationArray = this.locationFormArray(destinationIndex);
    locationArray.clear();
    locations.forEach((location: any, locationIndex: number) => {
      const locationGroup = this.createLocationFormGroup(location, null, null);
      locationGroup.patchValue({
        locationName: location.locationName || ""
      });
      locationArray.push(locationGroup);
      this.hotelsFormArray(destinationIndex, locationIndex).clear();
      location.hotels.forEach((hotel: any, hotelIndex: number) => {
        const hotelGroup = this.createHotelFormGroup(null, null, null);
        hotelGroup.patchValue({
          hotelName: hotel.hotelName,
          hotelType: hotel.hotelType,
          noOfRooms: hotel.totalRooms,
          noOfNights: hotel.noOfNights || 0,
          roomCategory: hotel.roomCategory,
          roomType: hotel.roomType,
          checkIn: this.convertToDate(hotel.checkIn),
          checkInTime: this.convertToDate(hotel.checkIn),
          checkOut: this.convertToDate(hotel.checkOut),
          checkOutTime: this.convertToDate(hotel.checkOut),
          mealPlan: hotel.mealPlan,
          costPerAdult: { inputValue: hotel.costPerAdult, dropdownValue: hotel.noOfAdults },
          costPerChild: { inputValue: hotel.costPerChild, dropdownValue: hotel.noOfChildren > this.noOfChildren ? this.childrenAboveTwo : hotel.noOfInfants },
          costPerInfant: { inputValue: hotel.costPerInfant, dropdownValue: hotel.noOfInfants > this.noOfChildren ? this.childrenBelowTwo : hotel.noOfInfants },
          extraBeds: hotel.extraBeds || 0
        });
        this.hotelsFormArray(destinationIndex, locationIndex).push(hotelGroup);
      });
    });
  }

  addHotelAtLocation(destinationIndex: number, locationIndex: number, hotelIndex: number) {
    let hotelDetails = this.hotelsFormArray(destinationIndex, locationIndex).at(hotelIndex)?.value;

    let hotelGroup = this.createHotelFormGroup(null, null, null);

    hotelGroup.patchValue({
      ...hotelDetails,
      hotelName: ""
    });

    this.hotelsFormArray(destinationIndex, locationIndex).insert(hotelIndex + 1, hotelGroup);
  }

  addLocationAtDestination(destinationIndex: number) {
    this.locationFormArray(destinationIndex).push(this.createLocationFormGroup(null, null, null))
  }

  addValidationOfCost() {
    const dataArray = this.accommodationForm.get('data') as FormArray;
    dataArray.controls.forEach((destinationGroup: any) => {
      const locationsArray = destinationGroup.get('locations') as FormArray;
      locationsArray.controls.forEach((locationGroup: any) => {
        const hotelsArray = locationGroup.get('hotels') as FormArray;
        hotelsArray.controls.forEach((hotelGroup: any) => {
          hotelGroup.get('costPerAdult')?.setValidators(Validators.required);
          if (this.noOfChildren) {
            hotelGroup.get('costPerChild')?.setValidators(Validators.required);
            hotelGroup.get('costPerInfant')?.setValidators(Validators.required);
            hotelGroup.get('costPerChild')?.enable();
            hotelGroup.get('costPerInfant')?.enable();
          } else {
            hotelGroup.get('costPerChild')?.setValidators([]);
            hotelGroup.get('costPerChild')?.disable();
            hotelGroup.get('costPerInfant')?.setValidators([]);
            hotelGroup.get('costPerInfant')?.disable();
          }
          hotelGroup.get('totalAccommodationCost')?.setValidators(Validators.required);

          hotelGroup.get('costPerAdult')?.updateValueAndValidity();
          hotelGroup.get('costPerChild')?.updateValueAndValidity();
          hotelGroup.get('costPerInfant')?.updateValueAndValidity();
          hotelGroup.get('totalAccommodationCost')?.updateValueAndValidity();
        });
      });
    });
  }

  /////////////////////////
  async onSubmit(): Promise<boolean> {
    if (!this.accommodationForm.valid) {
      this.accommodationForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControlInContainer(".itinerary-model-container .itinerary-model-content-main .itinerary-model-content-inner .itinerary-model-content");
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");

      return false;
    }

    const formData = await this.serializeFormData(this.accommodationForm.getRawValue());

    if (this.editQuote) {
      this.finalizeFormSubmission(formData);
      // Following edit is used to update hotels data in cost and pricing.
      this.hotelsDataUpdated.emit(formData.data);
      this.updateQuote.emit();
      return true;
    }

    return this.addNewAccommodation(formData);
  }

  private async addNewAccommodation(formData: any): Promise<boolean> {
    try {
      const data = await this._itineraryService.addAccommodationDetails(formData).toPromise();
      this._responseNotificationService.showMessage("Accommodation Added!");
      this.finalizeFormSubmission(data);
      return true;
    } catch (error) {
      console.error("Error adding accommodation", error);
      return false;
    }
  }

  private finalizeFormSubmission(data: any): void {
    this.accommodationForm.markAsPristine();
    data.dataSaved = true;
    this.storeFormData.emit(data);
  }

  //////////////////////

  private async serializeFormData(formData: any) {
    const serializedData = {
      itineraryId: this.itineraryId,
      leadId: this.leadId,
      note: formData.sectionNote,
      data: formData.data.map((destination: any) => {
        return {
          destination: destination.destination,
          locations: destination.locations.map((location: any) => {
            return {
              locationName: location.locationName,
              hotels: location.hotels.map((hotel: any) => {
                return {
                  hotelName: hotel.hotelName,
                  hotelType: hotel.hotelType,
                  totalRooms: hotel.noOfRooms,
                  noOfNights: hotel.noOfNights,
                  roomCategory: hotel.roomCategory,
                  roomType: hotel.roomType,
                  checkIn: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(hotel.checkIn), this.convertToDate(hotel.checkInTime))),
                  checkOut: this._globalService.convertDateToString(this._globalService.combineDateAndTime(this.convertToDate(hotel.checkOut), this.convertToDate(hotel.checkOutTime))),
                  mealPlan: hotel.mealPlan || [],
                  costPerAdult: hotel.costPerAdult?.inputValue,
                  costPerChild: hotel.costPerChild?.inputValue,
                  costPerInfant: hotel.costPerInfant?.inputValue,

                  noOfAdults: hotel.costPerAdult?.dropdownValue,
                  noOfChildren: hotel.costPerChild?.dropdownValue,
                  noOfInfants: hotel.costPerInfant?.dropdownValue,
                  totalCostOfAccommodation: hotel.totalAccommodationCost,
                  extraBeds: hotel.extraBeds
                };
              })
            };
          })
        };
      }),
      hotelTermsAndConditions: formData.hotelTermsAndConditions || [],
      organizationId: this.storedFormData?.organizationId,
      id: this.storedFormData ? this.storedFormData.id : null,
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      ...(this.storedFormData && { createDate: this.storedFormData.createDate })
    };

    return serializedData;
  }


  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.accommodationForm.dirty || this.accommodationForm.invalid) && this.accommodationForm.touched;
  }


  storeDataToParent() {
    this.serializeFormData(this.accommodationForm.getRawValue()).then(formdata => {
      formdata.dataInvalid = true;
      this.storeFormData.emit(formdata);
      this.viewChange.emit(true);
    })
  }

  gettingPopulatedHotelvalues(event: any, destinationIndex: number, locationIndex: number, hotelIndex: number) {
    const accommodationGroup = this.hotelsFormArray(destinationIndex, locationIndex).at(hotelIndex) as FormGroup;
    accommodationGroup.patchValue({
      hotelType: event?.hotelDetails?.hotelCategory,
      roomCategory: event?.roomDetailsAndPricing[0]?.roomType,
      mealPlan: event?.roomDetailsAndPricing[0]?.mealPlans,
    });
  }

  setDefaultLov(item:any, type:string, formControlName:string){
    const payload:any = {
      name: item.name
    }
    this._lovDataService.addDefaultLovData(type, payload).subscribe({
      next: (res) => {
        this._responseNotificationService.showMessage("Item added to default list");
        // make addedByUser false for item
        const currentItems = this.accommodationForm.get(formControlName)?.value || [];
        const updatedItems = currentItems.map((i: any) => {
          if(i.key === item.key){
            i.addedByUser = false;
          }
          return i;
        });
        this.accommodationForm.patchValue({ [formControlName]: updatedItems });
        this.accommodationForm.markAsDirty();
        this.accommodationForm.markAsTouched();
      },
      error: (err) => {
        console.error("Error adding default", err);
        this._responseNotificationService.showMessage("Error adding default", true);
      }
    });
  }

  async removeDefaultLov(item:any, type:string, formControlName:string){
    let flag = await this._globalService.confirmActionPopup("Removing the item from default list will affect all users in the organization. Please confirm to proceed.", "Confirm to proceed", "Confirm");
    if(!flag){
      return;
    }
    this._lovDataService.removeDefaultLovData(type, item.key).subscribe({
      next: (res) => {
        this._responseNotificationService.showMessage("Item removed from default list");
        const currentItems = this.accommodationForm.get(formControlName)?.value || [];
        const updatedItems = currentItems.filter((i: any) => i.key !== item.key);
        this.accommodationForm.patchValue({ [formControlName]: updatedItems });
        this.accommodationForm.markAsDirty();
        this.accommodationForm.markAsTouched();
      },
      error: (err) => {
        console.error("Error removing default", err);
        this._responseNotificationService.showMessage("Error removing default", true);
      }
    });
  }
}